import { http } from "../core";
import { URL } from "./_url";
import { StatusCode } from "../constant";

const apiFetchLotInfo = async (neighborhoodId: string, lotId: string, mode: string) => {
  const response = await http.get(URL.FETCH_LOT_INFO(neighborhoodId, lotId, mode));
  return response || null;
};

const apiFetchLots = async (neighborhoodId: string, neighborhoodType: string, mode: string) => {
  const response = await http.get(URL.FETCH_LOTS(neighborhoodId, neighborhoodType, mode));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
};

const apiFetchAminityInfo = async (amenityId: string) => {
  const response = await http.get(URL.FETCH_AMINITY_INFO(amenityId));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
}

const apiFetchLotsJobStatus = async (jobNumber: string) => {
  const response = await http.get(URL.FETCH_LOT_STATUS(jobNumber));
  if (response && response.status >= StatusCode.BADREQUEST) {
    throw new Error(response.status);
  }
  return response || null;
}
export { apiFetchLotInfo, apiFetchLots, apiFetchAminityInfo, apiFetchLotsJobStatus };
